export default "/fonts/vendor/primeicons/primeicons.woff?e61f3495a7ecd3d571a4c9a98797e955";